import React from "react";

export default function ValidateComponent() {
  return <span style={{ color: "red" }}>*</span>;
}
